// extracted by mini-css-extract-plugin
export default {"box":"addHeaders_box__apLr8","title":"addHeaders_title__iCNqN"};